module.exports = __webpack_public_path__ + "static/feature-saved-reports-a1fc813547f41e7e031c968be460fea8.png";